import { render, staticRenderFns } from "./SentencePreviewHtml.vue?vue&type=template&id=b553c4f0"
import script from "./SentencePreviewHtml.vue?vue&type=script&lang=js"
export * from "./SentencePreviewHtml.vue?vue&type=script&lang=js"
import style0 from "./SentencePreviewHtml.vue?vue&type=style&index=0&id=b553c4f0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports